import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { createContext, memo, ReactNode, useCallback, useContext } from 'react';

export type AppBottomSheetContextType = {
  finish: (callback?: () => void) => void;
};

export const AppBottomSheetContext = createContext<AppBottomSheetContextType>(
  null as any,
);

export const useAppBottomSheetContext = () => useContext(AppBottomSheetContext);

export const AppBottomSheetProvider = memo(
  ({
    onFinish,
    children,
  }: {
    onFinish: (callback?: () => void) => void;
    children?: ReactNode;
  }) => {
    const navigation = useNavigation<StackNavigationProp<any>>();

    const finish = useCallback(
      (callback?: () => void) => {
        onFinish(callback);
        navigation.goBack();
      },
      [navigation, onFinish],
    );

    return (
      <AppBottomSheetContext.Provider value={{ finish }}>
        {children}
      </AppBottomSheetContext.Provider>
    );
  },
);
